import React from 'react';
import { hot } from 'react-hot-loader'
import moment from 'moment-timezone';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import Dash from './dashboard';
import Login from './login';
import Users from './Users';
import Verifier from './Verifier';

import {withAuthentication} from './utils/auth';
import * as routes from './routes';
// <Route exact strict path='/verify' component={() => <Verifier/>} />
moment.tz.setDefault("Europe/Paris");
// console.log("TZ: ", moment.tz.names());

const App = () =>
  <Router>
    <div className="app">

      <Route exact path={routes.LOGIN} component={() => <Login />} />
      <Route path={routes.DASH} component={() => <Dash />} />

    </div>
  </Router>

export default withAuthentication(hot(module)(App));



// WEBPACK FOOTER //
// ./src/App.js